import builder from '../builder';
import DragIcon from '../../streamline-icons/bold/drag.svg';

export default builder('DragBold', DragIcon);
